import { BiLogger, BiLoggerFactory } from './types';

export { BiLoggerProvider } from './BiLoggerProvider';
export { withBiLogger } from './withBiLogger';
export type { BiLogger } from './types';

export const createBiLogger = (biLoggerFactory: BiLoggerFactory): BiLogger => {
  return biLoggerFactory.logger();
};
